import { createReducer } from "@reduxjs/toolkit";
import { JoinedConferenceState } from "./model";
import { ConferenceMode } from "../../AuviousApi";
import { ConferenceEventProcessor } from "./ConferenceEventProcessor";
import { joinConferenceRequest, joinConferenceSuccess, joinConferenceFailure, leaveConferenceRequest, leaveConferenceSuccess, leaveConferenceFailure, endConferenceRequest, endConferenceSuccess, endConferenceFailure, getConferenceStateSuccess, conferenceEvent, } from "./actions";
import { registerRequest } from "../actions";
export const joinedConferencesReducer = createReducer([], {
    [joinConferenceRequest.type]: (state, action) => {
        const conferenceId = action.payload;
        // assert that we're not already joined
        // an endpoint can only join once a specific conference
        const isAlreadyJoined = state.filter((joinedConference) => joinedConference.conferenceId === conferenceId).length > 0;
        if (isAlreadyJoined) {
            throw new Error(`Already joined to ${conferenceId}`);
        }
        state.push({
            state: JoinedConferenceState.JOINING,
            conferenceId,
            mode: ConferenceMode.UNKNOWN,
        });
    },
    [joinConferenceSuccess.type]: (state, action) => {
        const { conferenceId, mode } = action.payload;
        const joinedConference = state.filter((item) => item.conferenceId === conferenceId)[0];
        joinedConference.state = JoinedConferenceState.JOINED;
        joinedConference.mode = mode;
    },
    [joinConferenceFailure.type]: (state, action) => {
        const conferenceId = action.payload.conferenceId;
        return state.filter((item) => item.conferenceId !== conferenceId);
    },
    [leaveConferenceRequest.type]: (state, action) => {
        const conferenceId = action.payload.name;
        const joinedConference = state.filter((item) => item.conferenceId === conferenceId)[0];
        joinedConference.state = JoinedConferenceState.LEAVING;
    },
    [leaveConferenceSuccess.type]: (state, action) => {
        const conferenceId = action.payload;
        return state.filter((item) => item.conferenceId !== conferenceId);
    },
    [leaveConferenceFailure.type]: (state, action) => {
        const conferenceId = action.payload.conferenceId;
        return state.filter((item) => item.conferenceId !== conferenceId);
    },
    [endConferenceRequest.type]: (state, action) => {
        const conferenceId = action.payload.name;
        const joinedConference = state.filter((item) => item.conferenceId === conferenceId)[0];
        joinedConference.state = JoinedConferenceState.ENDING;
    },
    [endConferenceSuccess.type]: (state, action) => {
        const conferenceId = action.payload;
        return state.filter((item) => item.conferenceId !== conferenceId);
    },
    [endConferenceFailure.type]: (state, action) => {
        const conferenceId = action.payload.conferenceId;
        return state.filter((item) => item.conferenceId !== conferenceId);
    },
    [getConferenceStateSuccess.type]: (state, action) => {
        const conferenceId = action.payload.id;
        const joinedConference = state.filter((item) => item.conferenceId === conferenceId)[0];
        joinedConference.conferenceState = action.payload;
    },
    [conferenceEvent.type]: (state, action) => {
        const conferenceId = action.payload.conferenceId;
        const joinedConference = state.filter((item) => item.conferenceId === conferenceId)[0];
        ConferenceEventProcessor.processEvent(joinedConference.conferenceState, action.payload);
    },
    [registerRequest.type]: () => {
        return [];
    },
});
